import { render } from "./app-footer.vue?vue&type=template&id=4be680be&scoped=true"
const script = {}

import "./app-footer.vue?vue&type=style&index=0&id=4be680be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be680be"]])

export default __exports__